module.exports = __webpack_public_path__ + "img/Vector.63ae981a.svg";